import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/procurePilot")({
  component: ProcurePilotLayout,
});

function ProcurePilotLayout() {
  return <Outlet />;
}
